export default __webpack_public_path__ + "static/media/group-5907.08902dd8.png";